module.exports = __webpack_public_path__ + "img/video-default-img.1cbc09a5.png";